function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawCollection = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1015.56 783.53",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 535.54,
    y1: 705.46,
    x2: 535.54,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 1010.92,
    y1: 819.06,
    x2: 1010.92,
    y2: 308.97,
    gradientTransform: "matrix(-1 0 0 1 1257.03 0)",
    xlinkHref: "#prefix__a"
  })), React.createElement("path", {
    d: "M637.08 126.32c-42.28 26.74-97.12 25-145.17 11.1s-92.2-38.69-139-56.3a490.71 490.71 0 0 0-122.13-28.76C171.11 46.19 104.47 53.7 62.9 96.93c-46.3 48.15-42.75 135 7.33 179.18 25.47 22.48 58.83 33.51 87.91 51.06s56 46.7 53.54 80.58c-2.29 31.36-28.95 55.43-56.55 70.53-21.32 11.67-47.59 24.41-50.16 48.58-2.49 23.39 19.6 41.72 40.69 52.14 68.79 34 153.56 33.67 222.09-.86 24.45-12.32 46.93-28.7 72.57-38.3 67.32-25.21 141.51.17 212.8 9.45a469.28 469.28 0 0 0 181-11.91c35.31-9.42 70.75-23.82 95.55-50.65 17.88-19.35 29-43.83 39.48-68q16.74-38.68 32.17-77.9c6.18-15.7 12.25-31.7 13.85-48.5 2.89-30.43-9.29-60.51-25.87-86.2-39.37-61-105.68-103.86-177.45-114.75s-147.86 10.39-203.56 56.92",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 135.74,
    cy: 756.99,
    rx: 135.74,
    ry: 26.54,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 538.99,
    cy: 701.56,
    rx: 284.54,
    ry: 26.54,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M732.13 512.6s39.89-70.66 100-91c25.21-8.55 47.22-24.62 62.27-46.58a207.22 207.22 0 0 0 18.37-33.05",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M950.51 328.89c-6.85 6.64-38.73 13.51-38.73 13.51s7.82-31.65 14.67-38.3a17.273 17.273 0 0 1 24.06 24.79zM932.47 386.18c-9.35 1.85-39.85-9.71-39.85-9.71s23.77-22.32 33.13-24.18a17.275 17.275 0 0 1 6.72 33.89zM866.81 448.17c-9-3.12-29.5-28.49-29.5-28.49s31.79-7.28 40.8-4.16a17.28 17.28 0 0 1-11.3 32.65zM806.57 483.88c-9.41-1.55-33.9-23.09-33.9-23.09s30.11-12.54 39.52-11a17.27 17.27 0 1 1-5.62 34.08zM866.04 351.77c0 9.54 17.25 37.21 17.25 37.21s17.29-27.66 17.29-37.2a17.27 17.27 0 1 0-34.54 0zM796.11 394.4c2.85 9.1 27.6 30.34 27.6 30.34s8.22-31.56 5.37-40.66a17.288 17.288 0 0 0-33 10.32zM733.81 445.19c1.3 9.46 22.1 34.58 22.1 34.58s13.44-29.71 12.17-39.17a17.274 17.274 0 1 0-34.24 4.6z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M950.51 328.89c-6.85 6.64-38.73 13.51-38.73 13.51s7.82-31.65 14.67-38.3a17.273 17.273 0 0 1 24.06 24.79zM932.47 386.18c-9.35 1.85-39.85-9.71-39.85-9.71s23.77-22.32 33.13-24.18a17.275 17.275 0 0 1 6.72 33.89zM866.81 448.17c-9-3.12-29.5-28.49-29.5-28.49s31.79-7.28 40.8-4.16a17.28 17.28 0 0 1-11.3 32.65zM806.57 483.88c-9.41-1.55-33.9-23.09-33.9-23.09s30.11-12.54 39.52-11a17.27 17.27 0 1 1-5.62 34.08zM866.04 351.77c0 9.54 17.25 37.21 17.25 37.21s17.29-27.66 17.29-37.2a17.27 17.27 0 1 0-34.54 0zM796.11 394.4c2.85 9.1 27.6 30.34 27.6 30.34s8.22-31.56 5.37-40.66a17.288 17.288 0 0 0-33 10.32zM733.81 445.19c1.3 9.46 22.1 34.58 22.1 34.58s13.44-29.71 12.17-39.17a17.274 17.274 0 1 0-34.24 4.6z",
    opacity: 0.25
  }), React.createElement("path", {
    d: "M734.42 511.19s7.84-80.76 54.5-123.71c19.59-18 33.2-41.65 38-67.82a206.91 206.91 0 0 0 3.41-37.66",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M859.62 254.77c-3.56 8.85-29.92 28-29.92 28s-5.68-32.11-2.11-41a17.27 17.27 0 0 1 32 12.91zM866.35 314.43c-7.8 5.49-40.36 7.28-40.36 7.28s12.68-30 20.49-35.53a17.27 17.27 0 0 1 19.87 28.25zM831.44 397.71c-9.5.8-38.52-14.09-38.52-14.09s26.12-19.53 35.63-20.33a17.27 17.27 0 1 1 2.89 34.42zM790.81 454.77c-9.23 2.39-40.35-7.38-40.35-7.38s22.44-23.67 31.68-26.06a17.273 17.273 0 0 1 8.67 33.44zM791.66 309.87c3.86 8.72 30.85 27 30.85 27s4.6-32.28.74-41a17.277 17.277 0 0 0-31.59 14zM745.02 377.21c6.3 7.16 37.53 16.55 37.53 16.55s-5.28-32.18-11.57-39.35a17.29 17.29 0 1 0-26 22.8zM708.67 448.88c5 8.13 34.19 22.66 34.19 22.66s.24-32.61-4.75-40.74a17.274 17.274 0 1 0-29.44 18.08z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "url(#prefix__a)",
    d: "M281.84 0v705.46h507.4V0h-507.4z"
  }), React.createElement("path", {
    fill: "#f6f7f9",
    d: "M286.29 6.19h498.5v26.89h-498.5z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M286.29 6.19h498.5v26.89h-498.5z",
    opacity: 0.2
  }), React.createElement("path", {
    fill: "#f6f7f9",
    d: "M286.29 33.08h498.5v666.19h-498.5z"
  }), React.createElement("circle", {
    cx: 299.4,
    cy: 19.63,
    r: 4.56,
    fill: "#f6f7f9"
  }), React.createElement("circle", {
    cx: 311.76,
    cy: 19.63,
    r: 4.56,
    fill: "#f6f7f9"
  }), React.createElement("circle", {
    cx: 324.12,
    cy: 19.63,
    r: 4.56,
    fill: "#f6f7f9"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M375.26 74.15h320.55V86.7H375.26z",
    opacity: 0.2
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M653.22 74.15h42.59V86.7h-42.59z"
  }), React.createElement("g", {
    opacity: 0.2,
    fill: primaryColor
  }, React.createElement("path", {
    opacity: 0.2,
    d: "M333.82 330.62h403.44v144.49H333.82z"
  }), React.createElement("path", {
    d: "M737.26 330.63h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-18.45 4.56h-1v12h1v-12zm0 24h-1v12h1v-12zm0 24h-1v12h1v-12zm0 24h-1v12h1v-12zm0 24h-1v12h1v-12zm0 24h-1v12h1v-12zm15.06 18.93h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm3.38-19.62h-1v12h1v-12zm0-24h-1v12h1v-12zm0-24h-1v12h1v-12zm0-24h-1v12h1v-12zm0-24h-1v12h1v-12zm0-24h-1v12h1v-12z"
  })), React.createElement("path", {
    d: "M118.73 506.66s4.26 10.83 2.73 13.49c0 0 .77 8 11.09 13.49s22 18.62 22 18.62a14 14 0 0 0 9.2 6.36c.1 1.26.17 2 .17 2l.54.23c-.12.44-.24.9-.36 1.37-.28 1.09-.56 2.25-.82 3.45-1.71 7.79-2.74 17.45.71 22.88a18.92 18.92 0 0 1 1.26 2.29c4.66 9.88 1.47 22.28 1.47 22.28s4.08 28.12 5.86 32.68c1.27 3.23.1 7.74-.69 10.09a11.26 11.26 0 0 0-.58 3.5v10s-2 8.36-1 10.64-1.78 8.62-1.78 8.62-6.63 27.61-3.83 32.17 2.55 14.69 2.55 14.69 5.35 39.52 7.4 41a24.35 24.35 0 0 1 4.33 5.07s-3.64 8.95-1.45 12.64a2.53 2.53 0 0 0 .18.27c-.4 1-1.3 3.49-1.79 5.39-.16.62-.32 1.41-.46 2.28a29 29 0 0 0-.39 5.08l-.16.14.17.15a8.41 8.41 0 0 0 .33 2.23c.76 2.28 6.5 2.28 6.5 2.28s10.26 2.92 14.85 5.2 7.71 1.07 7.71 1.07c10.52 2.41 24-1.77 28.11-2.59s5.68-6.08.63-7.1a10.76 10.76 0 0 1-1.88-.57A15.38 15.38 0 0 1 225 803a128.1 128.1 0 0 0-10.74-9.19 31.36 31.36 0 0 1-6.73-6.77 7 7 0 0 0-3.8-1.88 4.08 4.08 0 0 0-.85-5.09 4.13 4.13 0 0 0-1.17-5.13l-1.89-1.46.44-.51a4.12 4.12 0 0 0 .38-4.85c-.82-1.37-1.62-3.8-1.83-8.06-.52-9.88-3.06-13.68-3.06-13.68l1.53-45.1a63.56 63.56 0 0 1 0-7.34c.25-2.79 5-1 5.73-1.71s.89-4.37 2.93-5.39c.72-.36 1.35-1.63 1.85-3.12a18.09 18.09 0 0 0 .52-8.8 5.17 5.17 0 0 1 .94-4c2.3-3 1.53-13.42 1.53-13.42l3.53-21.72c5.6 18.43 12.73 40.63 15.09 42.24 4.08 2.78 3.56 6.58 3.56 6.58-3.31 4.06-2 21.54-2 21.54s0 48.38 2.39 51.68 7 13.42 7 13.42-13.6 12-3 18.13l.45 5.12a1.57 1.57 0 0 0-.17.22 9.91 9.91 0 0 0-2 4.19l-.07.08c-.19 1.62.52 3.21 3.51 3.88 7.15 1.58 32.13 1.46 32.13 1.46l14 2.21s24 2.28 26.7-5.13-2.1-7-2.1-7h-.19l-10-.8s-12.68-4.88-17.34-8.24a99.81 99.81 0 0 1-10.38-9.25 4.05 4.05 0 0 0-2.64.49l-.43-.43-.69-.69 2.63-4c2.63-4.56-7.69-13.18-7.69-13.18s2.76-10.64 1.74-11.14-1.69-10.16-1.69-10.16 2.51-35 1.49-38.25c-.46-1.48.27-3.07 1.21-4.36a10.84 10.84 0 0 0 2-6.79c-.08-2 .23-4.27 1.67-5.82 3.06-3.3 0-17.48 0-17.48l-2.54-18.75v-29.78a47.14 47.14 0 0 0-3.13-16.77 47.76 47.76 0 0 1-2.58-11.55l.85.25a3.54 3.54 0 0 1-.9-.74c-.05-.48-.11-1-.15-1.45-.81-9.38-5.78-18.49-9.27-23.86-.8-3.14.09-16.23.09-16.23 4-6.84.19-16.72.19-16.72s-4-46.74-6.5-53.2-3.63-46.55 2.3-46.17 44.16-19 44.16-19-.95-1.52 11.67-6.65 31-21.09 31-21.09l25.43-30.4a.64.64 0 0 1-.28 0l.52-.17a21.52 21.52 0 0 0 13.34-11.46c4.4-9.66-4.41-22.73-10.18-28.6L358 309c-1.47 1.21-.93 6.54-3.33 12.25a130.81 130.81 0 0 0-5 15.6l-.26 1-.24-.44L335.8 348l-12.62 10.26s-27.92 13.49-31.36 16.91-4.59 2.47-7.64 3.23-3.45 2.85-4.4 2.66-2.68 2.66-4 2.28-4.2 1.14-6.12 1.52-15.5 6.14-15.5 6.14c-8.42-4.18-31.17-2.47-31.17-2.47s-7.46-4.37-9.56 0a7.22 7.22 0 0 1-6.5 4.18l-9.07-3.86c0-.24 0-.49.07-.73v-.15c.07-.57.16-1.11.25-1.63a30.13 30.13 0 0 0 10.41-49.12l-.79-.76a13.23 13.23 0 0 0 2.61-1.62 1.39 1.39 0 0 0 .56-.71.79.79 0 0 0-.08-.6 1.81 1.81 0 0 0-1-1.11c-2.76-1.49-5.81-1-8.2-3.39a5.36 5.36 0 0 1-1.25-1.93 3.75 3.75 0 0 1 0-2.41c.67-1.78 2.83-3 2.7-4.92h-.09v-.33a17 17 0 0 1-7.14 1.22l.45-2h.17l.24-1.06-.17.05.07-.34-6.72 1.8a1.69 1.69 0 0 1-1.51-.09 2.53 2.53 0 0 1-.52-1.05c-.58-1.41-2.45-1.86-3.92-1.46a16.32 16.32 0 0 0-4 2.19c-4.35 2.65-9.66 3-14.72 3.64s-10.44 1.73-14 5.37c-4.72 4.86-4.66 12.51-7.61 18.6a16.45 16.45 0 0 0-1.35 3.07 12 12 0 0 0 .08 4.85c.72 4.68 1.51 9.54 4 13.55l-.27-.32q.45.79 1 1.56c1.79 2.52 4.31 4.57 6.22 7-.12-.23-.27-.44-.4-.67a13.65 13.65 0 0 1 2.5 4.15c.66 1.88.8 4 1.59 5.78a6.25 6.25 0 0 0 1.14 1.9 5.78 5.78 0 0 0 4.84 1.66 41.55 41.55 0 0 1-3 6.24l-.15.26a4.76 4.76 0 0 0-1.5.17c-2.22.41-9.82 6.94-9.82 6.94l-13.57 12c-20.46 16-15.87 40.85-15.87 40.85v12.6s-4 13.49 0 27zm41.1-111.25zm-11.22 111.44s7.08-5.7 4.59-9.12c-.8-1.1-1.12-3.41-1.19-6l9.22 20.48s5.55 8.93 2.68 12.92v.07l-11-12.8s-.47-5.55-4.3-5.55z",
    transform: "translate(-104.19 -58.23)",
    fill: "url(#prefix__b)"
  }), React.createElement("path", {
    d: "M243.04 286.26l6 11.71a23.63 23.63 0 0 0 5.61-1.17 21.29 21.29 0 0 0 13.17-11.39c5.38-11.9-9.25-29-13.4-31.24s-2.27 4.53-5.38 12a128.21 128.21 0 0 0-4.89 15.5c-.68 2.72-1.11 4.59-1.11 4.59zM51.5 347.14l9.63 14.35s45.5 21.71 36.82-3.77c-3.83-11.23-4.29-19.46-3.6-25.14a.88.88 0 0 0 0-.16c.9-7.11 3.58-10.2 3.58-10.2s-44.36-22.7-37.76-7.17a21.44 21.44 0 0 1 1.64 10.22 34.91 34.91 0 0 1-4.78 14.17 46.65 46.65 0 0 1-5.53 7.7z",
    fill: "#cc818c"
  }), React.createElement("path", {
    d: "M65.29 631.22s-6.55 27.43-3.78 32 2.51 14.6 2.51 14.6 5.29 39.27 7.31 40.78a24.36 24.36 0 0 1 4.28 5s-3.6 8.89-1.44 12.56a3 3 0 0 0 1.44 1.28c3.37 1.42 15.83-4.89 22.93-8.76a4 4 0 0 0 1.88-2.24 4 4 0 0 0-1.15-4.35 4.14 4.14 0 0 0-1.16-5.1l-1.86-1.45.43-.51a4.14 4.14 0 0 0 .38-4.82c-.82-1.36-1.61-3.77-1.82-8-.5-9.81-3-13.59-3-13.59l1.49-44.85a65.35 65.35 0 0 1 0-7.3c.25-2.77 4.91-.94 5.67-1.7s.87-4.34 2.89-5.35c.71-.36 1.33-1.62 1.83-3.1a18.21 18.21 0 0 0 .51-8.74 5.15 5.15 0 0 1 .93-4c2.26-3 1.51-13.34 1.51-13.34l3.48-21.58c5.53 18.31 12.57 40.37 14.9 42 4 2.77 3.52 6.54 3.52 6.54-3.27 4-2 21.41-2 21.41s0 48.07 2.36 51.35 7 13.33 7 13.33-13.49 12-2.88 18.06l.11.07c10.83 6 33.24-10.82 33.24-10.82l-2.35-2.34-.68-.69 2.6-4c2.6-4.53-7.59-13.09-7.59-13.09s2.72-10.58 1.72-11.08-1.72-10.07-1.72-10.07 2.47-34.74 1.47-38c-.46-1.47.26-3 1.19-4.33a10.77 10.77 0 0 0 1.93-6.75c-.07-2 .23-4.24 1.66-5.78 3-3.28 0-17.37 0-17.37l-2.52-18.63v-29.64a47.12 47.12 0 0 0-3-16.66 50.32 50.32 0 0 1-2.85-13.4c-.82-9.54-6-18.82-9.4-24.1-1.83-2.79-3.19-4.47-3.19-4.47l-80.54-3.15s-1.32 3.58-2.59 8.58c-.28 1.08-.56 2.23-.82 3.43-1.68 7.74-2.7 17.33.71 22.73a19.42 19.42 0 0 1 1.24 2.28c4.61 9.81 1.46 22.14 1.46 22.14s4 27.94 5.78 32.47c1.25 3.21.1 7.69-.68 10a11.18 11.18 0 0 0-.57 3.48v9.91s-2 8.31-1 10.57-1.77 8.58-1.77 8.58z",
    fill: "#444053"
  }), React.createElement("path", {
    d: "M61.59 532.54a20.79 20.79 0 0 1 1.22 2.23l4.54-.26c-.44-2.33 2.65-24.23 2.65-24.23l-9.13-.51c-1.68 7.78-2.7 17.37.72 22.77z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M60.81 531.77a19.42 19.42 0 0 1 1.24 2.28l4.54-.26c-.44-2.33 2.64-24.23 2.64-24.23l-9.13-.52c-1.66 7.73-2.68 17.34.71 22.73z",
    fill: "#444053"
  }), React.createElement("path", {
    d: "M60.81 531.77a19.42 19.42 0 0 1 1.24 2.28l4.54-.26c-.44-2.33 2.64-24.23 2.64-24.23l-9.13-.52c-1.66 7.73-2.68 17.34.71 22.73z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M74.17 736.16a3 3 0 0 0 1.44 1.28c3.37 1.42 15.83-4.89 22.93-8.76a4 4 0 0 0 1.88-2.24c-4-.74-6.69 3.76-6.69 3.76a6 6 0 0 0-8.3 2c-3.47 5.1-10.89 2.95-10.89 2.95s-.15.4-.37 1.01z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M72.08 751.6c.76 2.26 6.42 2.26 6.42 2.26s10.14 2.9 14.67 5.17 7.61 1.06 7.61 1.06c10.38 2.4 23.73-1.76 27.75-2.57s5.6-6 .63-7a10.3 10.3 0 0 1-1.86-.57 15.12 15.12 0 0 1-6.19-5 127.84 127.84 0 0 0-10.6-9.18 30.84 30.84 0 0 1-6.65-6.73c-5.91-5.22-10.13 2-10.13 2a6 6 0 0 0-8.3 2c-3.47 5.09-10.89 2.94-10.89 2.94s-1.33 3.41-1.95 5.86c-.16.62-.32 1.4-.46 2.27-.4 2.5-.61 5.79-.05 7.49z",
    fill: "#ff748f"
  }), React.createElement("circle", {
    cx: 89.39,
    cy: 734.98,
    r: 0.69,
    fill: "#575988"
  }), React.createElement("circle", {
    cx: 95.3,
    cy: 740.52,
    r: 0.69,
    fill: "#575988"
  }), React.createElement("circle", {
    cx: 101.31,
    cy: 745.49,
    r: 0.69,
    fill: "#575988"
  }), React.createElement("circle", {
    cx: 98.2,
    cy: 743.27,
    r: 0.69,
    fill: "#575988"
  }), React.createElement("circle", {
    cx: 92.22,
    cy: 737.57,
    r: 0.69,
    fill: "#575988"
  }), React.createElement("path", {
    d: "M72.08 751.6c.76 2.26 6.42 2.26 6.42 2.26s10.14 2.9 14.67 5.17 7.61 1.06 7.61 1.06c10.38 2.4 23.73-1.76 27.75-2.57s5.6-6 .63-7a10.3 10.3 0 0 1-1.86-.57 48.64 48.64 0 0 1-13.62 2.58c-10.26.44-18.38 0-18.38 0l-10.38-3.34a17.53 17.53 0 0 0-6.42-2.32c-2.2-.22-4.89-1.8-6.37-2.77-.4 2.51-.61 5.8-.05 7.5z",
    fill: "#dce6f2"
  }), React.createElement("path", {
    d: "M97.92 758.11a8.72 8.72 0 0 0 1.72-.17l-.15-.74a11 11 0 0 1-6.22-.87c-.93-.36-1.85-.8-2.75-1.22-1.06-.5-2.16-1-3.28-1.43l-1-.36c-.56-.19-1.14-.38-1.68-.61-.32-.13-.62-.28-.93-.43a10.37 10.37 0 0 0-2.33-.88 11.05 11.05 0 0 0-1.27-.17 10.63 10.63 0 0 1-1.15-.14 10.15 10.15 0 0 1-2.18-.81 10.93 10.93 0 0 0-2.34-.87l-.56-.09a2.66 2.66 0 0 1-1.62-.6l-.56.51a3.29 3.29 0 0 0 2.06.83l.53.09a11.34 11.34 0 0 1 2.18.81 10.42 10.42 0 0 0 2.34.87 10.74 10.74 0 0 0 1.24.15 10.83 10.83 0 0 1 1.18.16 9.41 9.41 0 0 1 2.16.83c.31.15.63.3.95.43.57.25 1.17.45 1.74.64l1 .35c1.09.4 2.17.91 3.22 1.4s1.84.87 2.8 1.24a13.42 13.42 0 0 0 4.9 1.08z",
    fill: "#575988",
    opacity: 0.5
  }), React.createElement("path", {
    d: "M95.49 633.04s-5.22-7.55-14.16-7.49-12.77-1-12.77-1 5.72 3.4 9.69 3.84 17.24 4.65 17.24 4.65zM92.47 634.77s-4.72-3.27-7.42-3.4-5-.38-5-.38a14.54 14.54 0 0 0 4.15 2c2.23.68 8.27 1.78 8.27 1.78zM91.46 637.07s-7.11.56-7.17 2.45M157.7 530.93c-.37.07-6.73-6.6-7.17-9.25a6.45 6.45 0 0 0-2.77-4.06s-4.09 1.64-.44 6.66 10.38 6.65 10.38 6.65zM60.19 315.05c1.45 3.42 2.72 3.68 2.45 7a25.05 25.05 0 0 0 5.76 4.53c4.5 2.67 9.4 7.9 15 7.9a29.76 29.76 0 0 0 11-2.07c.9-7.11 3.58-10.2 3.58-10.2s-44.39-22.69-37.79-7.16z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M53.39 302.97a30 30 0 1 0 30-30 30 30 0 0 0-30 30z",
    fill: "#cc818c"
  }), React.createElement("path", {
    d: "M51.5 347.14l9.63 14.35s45.5 21.71 36.82-3.77c-3.83-11.23-4.29-19.46-3.6-25.14h-.07a23.79 23.79 0 0 0-.91 5.78c-.14 3.92-.24 8.87-10 10.51-16.2 2.73-24.91-7.41-26.43-9.4a46.65 46.65 0 0 1-5.44 7.67zM243.04 286.26l6 11.71a23.63 23.63 0 0 0 5.61-1.17l.52-.63c-2.45.94-10.76-14.73-10.76-14.73l-.26.21c-.68 2.74-1.11 4.61-1.11 4.61zM60.94 505.62c19.43 8.43 86.66 1.24 86.66 1.24a8.54 8.54 0 0 1-.34-2.2c-1.83-2.79-3.19-4.47-3.19-4.47l-80.54-3.15s-1.32 3.58-2.59 8.58z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M94.27 333.3l9 3.84a7.12 7.12 0 0 0 6.42-4.16c2.08-4.34 9.44 0 9.44 0s22.47-1.7 30.77 2.46c0 0 13.41-5.67 15.3-6s4.72-1.89 6-1.51 3-2.46 4-2.27 1.32-1.89 4.35-2.64 4.15.19 7.55-3.21 31-16.8 31-16.8l12.38-10.24 13.21-10.57s8.31 15.67 10.77 14.72l-25.11 30.21s-18.13 15.86-30.59 21-11.51 6.6-11.51 6.6-37.76 19.26-43.62 18.88-4.72 39.46-2.26 45.88 6.44 52.82 6.44 52.82 3.77 9.82-.19 16.62c0 0-.94 14 0 16.42 0 0-67.65 7.24-86.85-1.32 0 0-2.83-31.34 0-35.3s-2.64-12.84-2.64-12.84l-12.08-27-29.45-29.64s-4.53-24.73 15.67-40.59l13.38-11.89s7.5-6.49 9.69-6.9 1.39 0 1.39 0 8.74 12.75 26.68 9.73c9.72-1.64 9.83-6.6 10-10.51a24.26 24.26 0 0 1 .86-5.79z",
    fill: "#67647e"
  }), React.createElement("path", {
    d: "M57.36 434.93s41.53 1.7 49.84 14.73c0 0-10.76-5.1-20.39-3.59s-29.45-11.14-29.45-11.14zM103.23 480.43s-19.63 1.32-23.79-2.83-4.16-6.61-4.16-6.61zM53.39 394.91s16.62 19.63-3.59 28.13zM151.75 356.96s-6 12.33-9.06 13.15zM172.14 351.67s-15.1 13.6-17.93 14.92c0 0 15.67-14.92 17.93-14.92zM111.92 338.65s14.53 21.71 5.09 34.92c0 0 5.29-15.67-5.09-34.92z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M75.28 503.09l4.44 4.18.62.58 5.15 4.86c.37.28.73.56 1.09.81 20.95 15 25.15-7.79 25.15-7.79s9.25 6 10.57 1.13-21.49-11.89-24.92-11.51a4 4 0 0 1-.91 0 14.81 14.81 0 0 1-4.69-1.66l-1-.55c-1.91-1.07-3.39-2.13-3.39-2.13z",
    fill: "#cc818c"
  }), React.createElement("path", {
    d: "M52.64 302.97a30 30 0 0 0 14.66 25.8 17.12 17.12 0 0 0 1.1-2.18c1.08-2.52 1.73-5.2 2.82-7.71a23.81 23.81 0 0 1 5.05-7.35 3.14 3.14 0 0 1 1.33-.92 3.65 3.65 0 0 1 2.76.76 12.6 12.6 0 0 0 4.18 1.84 4.5 4.5 0 0 0 4.2-1.27c1.17-1.4 1-3.45.67-5.24-.74-3.91-2-7.75-2-11.72s1.51-8.26 5-10.22c3-1.74 6.83-1.3 10.21-2.23a12.18 12.18 0 0 0 1.54-.53 30 30 0 0 0-51.51 21z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M106.18 277.23c.55.29 1.14.81 1 1.41a1.35 1.35 0 0 1-.55.7 12.94 12.94 0 0 1-4.75 2.44c-3.38.92-7.17.49-10.22 2.22-3.45 2-5 6.25-5 10.22s1.24 7.82 2 11.72c.34 1.79.51 3.84-.66 5.24a4.48 4.48 0 0 1-4.2 1.27 12.51 12.51 0 0 1-4.19-1.83 3.64 3.64 0 0 0-2.75-.77 3.43 3.43 0 0 0-1.34.92 24 24 0 0 0-5 7.36c-1.1 2.5-1.75 5.18-2.82 7.7a12.48 12.48 0 0 1-5.05 6.28c-2.39 1.32-5.72 1.22-7.56-.8s-1.71-4.86-2.58-7.33c-1.5-4.28-5.69-7-8.31-10.66-2.93-4.16-3.78-9.39-4.54-14.41a11.87 11.87 0 0 1-.08-4.82 17.6 17.6 0 0 1 1.33-3.06c2.91-6 2.86-13.64 7.52-18.47 3.49-3.62 8.8-4.73 13.8-5.34s10.24-1 14.53-3.61a15.54 15.54 0 0 1 3.94-2.18c1.45-.4 3.29 0 3.86 1.45a2.59 2.59 0 0 0 .52 1.05 1.63 1.63 0 0 0 1.48.08l6.65-1.78-.76 3.35a16.53 16.53 0 0 0 7-1.21c.13 1.89-2 3.12-2.67 4.89a4.53 4.53 0 0 0 1.3 4.6c2.37 2.35 5.38 1.91 8.1 3.37z",
    fill: "#585268"
  }), React.createElement("path", {
    d: "M133.12 728.32l.27 3 .11.07c10.83 6 33.24-10.82 33.24-10.82l-2.35-2.34a4.15 4.15 0 0 0-1 3.16l-4.57.25-5.48 5.91s-14.8 1.72-18.81.76z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M135.01 744.77c7.05 1.57 31.73 1.45 31.73 1.45l13.84 2.2s23.72 2.26 26.36-5.1-2.08-6.92-2.08-6.92h-.18l-9.88-.8s-12.52-4.85-17.12-8.19a99.79 99.79 0 0 1-10.26-9.19s-4.12-.8-4.05 4l-4.57.25-5.48 5.92s-14.8 1.71-18.81.75h-1.39l.64 7.3-.18.22c-.92 1.11-4.86 6.68 1.43 8.11z",
    fill: "#ff748f"
  }), React.createElement("circle", {
    cx: 160.56,
    cy: 726.41,
    r: 0.69,
    fill: "#575988"
  }), React.createElement("circle", {
    cx: 178.31,
    cy: 734.11,
    r: 0.69,
    fill: "#575988"
  }), React.createElement("circle", {
    cx: 187.45,
    cy: 736.88,
    r: 0.69,
    fill: "#575988"
  }), React.createElement("circle", {
    cx: 173.65,
    cy: 732.64,
    r: 0.69,
    fill: "#575988"
  }), React.createElement("circle", {
    cx: 182.9,
    cy: 735.5,
    r: 0.69,
    fill: "#575988"
  }), React.createElement("circle", {
    cx: 168.94,
    cy: 730.45,
    r: 0.69,
    fill: "#575988"
  }), React.createElement("circle", {
    cx: 164.29,
    cy: 728.43,
    r: 0.69,
    fill: "#575988"
  }), React.createElement("path", {
    d: "M135.01 744.77c7.05 1.57 31.73 1.45 31.73 1.45l13.84 2.2s23.72 2.26 26.36-5.1-2.08-6.92-2.08-6.92h-.18c-1.52 1.95-4.55 4.18-10.51 4.29l-17.06.69-17.68-1.26s-16.55-.5-19.25-1.06a39.68 39.68 0 0 1-6.6-2.43c-.92 1.14-4.86 6.71 1.43 8.14z",
    fill: "#dce6f2"
  }), React.createElement("path", {
    d: "M179.24 746.77a10.85 10.85 0 0 0 2.8-.35l-.2-.73a13.73 13.73 0 0 1-7-.32c-.84-.21-1.67-.46-2.49-.71a38.85 38.85 0 0 0-4.61-1.16 38.34 38.34 0 0 0-7.64-.22h-.54a117.78 117.78 0 0 1-22.67-1c-1.69-.28-3.61-.68-4.84-1.94l-.54.52c1.39 1.43 3.45 1.87 5.26 2.16a117 117 0 0 0 22.82 1h.54a37.52 37.52 0 0 1 7.49.22 36.75 36.75 0 0 1 4.51 1.14c.84.25 1.68.49 2.52.71a18.52 18.52 0 0 0 4.59.68z",
    fill: "#575988",
    opacity: 0.5
  }), React.createElement("path", {
    d: "M75.28 503.09l4.44 4.18 11-14.14c-1.91-1.07-3.39-2.13-3.39-2.13z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M25.26 387.17l-8.68 12.08v12.65s-4 13.4 0 26.81l-.44 11.7s4.21 10.76 2.7 13.41c0 0 .76 7.93 10.95 13.4s21.71 18.55 21.71 18.55 4.35 8.31 16.05 6.42l11.14 4.72 12.84-16.42-17.37-9.44s-6-8.12-9.63-7.74l-14.72-17.23s-.37-5.48-4.15-5.48c0 0 7-5.66 4.53-9.06s-.38-18.5-.38-18.5z",
    fill: "#67647e"
  }), React.createElement("path", {
    d: "M41.5 442.29s-19.83-.37-22.28 4.72 16.24-7.55 22.28-4.72zM80.26 506.86a5.44 5.44 0 0 0 .08 1 6.67 6.67 0 0 0 6.24 5.67h.36a6.66 6.66 0 0 0 6.66-6.67 6.51 6.51 0 0 0-.37-2.17c3.15-2.53 3.32-7.08 3.24-9.35a14.81 14.81 0 0 1-4.69-1.66 31.21 31.21 0 0 1-3.29 6.7 6.65 6.65 0 0 0-8.23 6.48z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M91.18 492.2s4.47 1 4.47 1.82 1 8.19-3.91 11.21-4.4-4.22-4.4-4.22 4.22-6.48 3.84-8.81z",
    fill: "#575988"
  }), React.createElement("circle", {
    cx: 86.18,
    cy: 506.86,
    r: 6.67,
    fill: "#e4aab4"
  }), React.createElement("circle", {
    cx: 86.18,
    cy: 506.86,
    r: 5.73,
    fill: "#dce6f2"
  }), React.createElement("path", {
    d: "M112.17 509.44s-14.1 11.71-32.22 4.28v5.67s12.08 8.3 23 3.27 9.22-13.22 9.22-13.22z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M112.17 507.93s-14.1 11.7-32.22 4.28v5.66s12.08 8.31 23 3.28 9.22-13.22 9.22-13.22z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M112.17 507.93s-14.1 11.7-32.22 4.28v5.66s12.08 8.31 23 3.28 9.22-13.22 9.22-13.22z",
    fill: "#444053"
  }), React.createElement("path", {
    d: "M111.81 507.93s-14.1 11.7-32.22 4.28v5.66s12.08 8.31 23 3.28 9.22-13.22 9.22-13.22z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M156.47 718.18s-18.88 3.47-21.65 4.22.76 2.08.76 2.08 17.23-3.09 20.89-6.3zM156.91 708.18c-.31 0-12.83-3.53-15.54-9.57M138.64 635.93s-5.07 6.67-8.35 6.49 5.37-6.74 8.35-6.49zM135.81 647.01s-2.14 4.72-5.29 3.21",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M123.94 543.36l-13.39 35.31s-1.89-22.72 2.1-29.52a11.81 11.81 0 0 1 11.29-5.79z",
    opacity: 0.05
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M90.98 263.6l.12-.51 2.15-.58-.24 1.06a17.16 17.16 0 0 1-2.03.03zM96.89 272.09l-.22-.21a4.51 4.51 0 0 1-1.3-4.6 6.39 6.39 0 0 1 1.07-1.7 16.73 16.73 0 0 0 3.1-.92c.13 1.89-2 3.12-2.66 4.89a3.82 3.82 0 0 0 .01 2.54zM61.19 330.13a12.47 12.47 0 0 0 5-6.28c1.07-2.51 1.73-5.19 2.82-7.7a23.83 23.83 0 0 1 5-7.35 3.23 3.23 0 0 1 1.34-.92 3.62 3.62 0 0 1 2.76.76 12.37 12.37 0 0 0 4.18 1.83 4.47 4.47 0 0 0 4.2-1.26c1.17-1.4 1-3.46.66-5.25-.73-3.9-2-7.75-2-11.72s1.5-8.25 4.95-10.21c3.05-1.74 6.84-1.31 10.22-2.23a12.92 12.92 0 0 0 4.75-2.43l.26-.24a6.94 6.94 0 0 1 .83.39c.54.29 1.13.81 1 1.41a1.46 1.46 0 0 1-.56.7 12.94 12.94 0 0 1-4.75 2.44c-3.38.92-7.17.48-10.22 2.22-3.45 2-5 6.25-4.95 10.22s1.23 7.82 2 11.72c.34 1.79.51 3.84-.66 5.24a4.48 4.48 0 0 1-4.2 1.27 12.57 12.57 0 0 1-4.18-1.83 3.67 3.67 0 0 0-2.76-.77 3.33 3.33 0 0 0-1.34.92 24 24 0 0 0-5 7.36c-1.09 2.5-1.75 5.18-2.82 7.7a12.45 12.45 0 0 1-5 6.27c-2.4 1.33-5.72 1.23-7.57-.8a6.05 6.05 0 0 1-1.13-1.89 6.48 6.48 0 0 0 7.17.43zM50.39 320.53c-1.89-2.38-4.37-4.42-6.14-6.93a16.66 16.66 0 0 1-1-1.54c2.31 2.91 5.44 5.26 7.14 8.47z"
  })), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    opacity: 0.2,
    d: "M548.33 258.35L286.29 310.6V163.26l233.79-46.62 28.25 141.71z"
  })), React.createElement("g", {
    opacity: 0.2,
    fill: primaryColor
  }, React.createElement("path", {
    opacity: 0.2,
    d: "M333.82 143.19h403.44v144.49H333.82z"
  }), React.createElement("path", {
    d: "M737.26 143.2h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-18.45 4.57h-1v12h1v-12zm0 24h-1v12h1v-12zm0 24h-1v12h1v-12zm0 24h-1v12h1v-12zm0 24h-1v12h1v-12zm0 24h-1v12h1v-12zm15.06 18.93h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm3.38-19.62h-1v12h1v-12zm0-24h-1v12h1v-12zm0-24h-1v12h1v-12zm0-24h-1v12h1v-12zm0-24h-1v12h1v-12zm0-24h-1v12h1v-12z"
  })), React.createElement("g", {
    opacity: 0.2,
    fill: primaryColor
  }, React.createElement("path", {
    opacity: 0.2,
    d: "M333.82 515.61h403.44V660.1H333.82z"
  }), React.createElement("path", {
    d: "M737.26 515.62h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-24 0h-12v1h12v-1zm-18.45 4.56h-1v12h1v-12zm0 24h-1v12h1v-12zm0 24h-1v12h1v-12zm0 24h-1v12h1v-12zm0 24h-1v12h1v-12zm0 24h-1v12h1v-12zm15.06 18.93h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm24 0h-12v1h12v-1zm3.38-19.62h-1v12h1v-12zm0-24h-1v12h1v-12zm0-24h-1v12h1v-12zm0-24h-1v12h1v-12zm0-24h-1v12h1v-12zm0-24h-1v12h1v-12z"
  })), React.createElement("path", {
    fill: "#f6f7f9",
    d: "M107.62 185.648l395.647-78.915 28.263 141.699-395.647 78.914z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.4,
    d: "M107.62 185.648l395.647-78.915 28.263 141.699-395.647 78.914z"
  }), React.createElement("path", {
    d: "M265.19 181.29a11.75 11.75 0 0 0-1.46 7.38 10 10 0 0 0 7.65-11.66 11.77 11.77 0 0 0-6.19 4.28zM421.53 153.28a11.74 11.74 0 0 0 6.28 4.14 10 10 0 0 0-7.9-11.49 11.75 11.75 0 0 0 1.62 7.35zM363.88 151.84a8.06 8.06 0 0 0 .74 5.11 6.86 6.86 0 0 0 2.28-9.3 8.07 8.07 0 0 0-3.02 4.19zM290.9 219.46a8.1 8.1 0 0 0 .74 5.12 6.87 6.87 0 0 0 2.28-9.31 8.07 8.07 0 0 0-3.02 4.19zM328.81 232.1a8.09 8.09 0 0 0 3.86 3.44 6.87 6.87 0 0 0-4.23-8.6 8.06 8.06 0 0 0 .37 5.16zM314.89 181.58a11.74 11.74 0 0 0 3.61 6.61 10 10 0 0 0-1.6-13.86 11.76 11.76 0 0 0-2.01 7.25zM362.71 183.9a11.75 11.75 0 0 0-1.3 7.41 10 10 0 0 0 7.4-11.83 11.73 11.73 0 0 0-6.1 4.42z",
    fill: "#f6f7f9"
  }), React.createElement("ellipse", {
    cx: 569.71,
    cy: 296.59,
    rx: 40.21,
    ry: 6.8,
    transform: "rotate(-11.28 222.565 794.92)",
    fill: "#f6f7f9"
  }), React.createElement("path", {
    d: "M479.65 224.2a11.62 11.62 0 0 0 2.62-6.42c0-2.35-1.46-4.86-3.78-5.26-2.59-.44-4.84 1.75-6.45 3.83s-3.48 4.45-6.11 4.6a10.46 10.46 0 0 0 1.26-10.25 4.08 4.08 0 0 0-1.27-1.78c-1.62-1.17-3.93-.07-5.31 1.38-4.38 4.6-4.42 11.82-3.21 18.06-1-2.15-1-4.58-1.47-6.89s-1.61-4.73-3.81-5.58a7.81 7.81 0 0 0-4.13-.14c-2.31.37-4.82 1.11-6 3.1-1.53 2.47-.33 5.86 1.82 7.82s5 2.88 7.7 4a15 15 0 0 1 5.64 3.58 4.19 4.19 0 0 1 .51.74l14.37-2.87a40.76 40.76 0 0 0 7.62-7.92z",
    fill: "#f6f7f9"
  }), React.createElement("path", {
    d: "M198.81 289.77s-11.42-21.76-6.72-40.4a37.26 37.26 0 0 0-1.62-23.5 62.64 62.64 0 0 0-5.38-10.1",
    fill: "none",
    stroke: "#f6f7f9",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M187.98 204.05c.57 2.83-2.93 12.07-2.93 12.07s-6.77-7.19-7.33-10a5.23 5.23 0 1 1 10.26-2zM199.59 218.05c-1.06 2.69-9 8.55-9 8.55s-1.77-9.72-.7-12.41a5.23 5.23 0 1 1 9.72 3.86zM204.57 244.95c-2.28 1.78-12.1 2.82-12.1 2.82s3.38-9.28 5.65-11.06a5.232 5.232 0 1 1 6.45 8.24zM203.75 266.15c-1.94 2.14-11.44 4.83-11.44 4.83s1.75-9.72 3.7-11.86a5.23 5.23 0 1 1 7.74 7zM179.91 229.29c2.42 1.57 12.3 1.73 12.3 1.73s-4.19-8.94-6.62-10.51a5.23 5.23 0 0 0-5.68 8.78zM179.27 254.1c2.78.77 12.25-2 12.25-2s-6.67-7.28-9.46-8.06a5.234 5.234 0 1 0-2.79 10.09zM181.95 278.29c2.62 1.24 12.43.07 12.43.07s-5.35-8.3-8-9.53a5.23 5.23 0 0 0-4.46 9.46zM236.53 240.5s3.21 2.83.49 8.6-4.95 10.63-3.08 13.52c0 0 3.76-10.46 8.3-11.5s.44-6-5.71-10.62z",
    fill: "#f6f7f9"
  }), React.createElement("path", {
    d: "M236.53 240.5a4.61 4.61 0 0 1 .73.95c5.5 4.35 8.86 8.77 4.59 9.74-4 .92-7.34 9-8.13 11.05.07.13.14.26.22.38s3.76-10.46 8.3-11.5.44-6-5.71-10.62z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M242.11 243.77c.24 1.17.29 2.15.13 2.18s-.48-.89-.72-2.07 0-.65.21-.68.15-.57.38.57z",
    fill: "#f6f7f9"
  }), React.createElement("path", {
    d: "M244.02 244.88c-.92.77-1.75 1.29-1.86 1.16s.55-.85 1.47-1.62.59-.27.7-.15.6-.15-.31.61zM223.07 243.19s-1.88 3.84 2.84 8.13 8.65 7.92 8 11.3c0 0-7.48-8.22-12.08-7.44s-2.67-5.41 1.24-11.99z",
    fill: "#f6f7f9"
  }), React.createElement("path", {
    d: "M223.07 243.19a4 4 0 0 0-.31 1.15c-3.42 6.13-4.82 11.49-.51 10.76 4-.68 10.24 5.51 11.75 7.08a3.11 3.11 0 0 1-.06.44s-7.48-8.22-12.08-7.44-2.7-5.41 1.21-11.99z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M219.18 248.38c.23 1.17.56 2.1.72 2.06s.1-1-.13-2.18-.29-.59-.45-.55-.37-.5-.14.67z",
    fill: "#f6f7f9"
  }), React.createElement("path", {
    d: "M217.81 250.1c1.15.36 2.11.52 2.16.36s-.84-.57-2-.93-.65 0-.7.13-.58.11.54.44z",
    fill: "#f6f7f9"
  }), React.createElement("ellipse", {
    cx: 303.56,
    cy: 349.65,
    rx: 28.44,
    ry: 4.81,
    transform: "rotate(-11.28 -43.504 847.936)",
    fill: "#f6f7f9"
  }), React.createElement("ellipse", {
    cx: 338.33,
    cy: 322.58,
    rx: 20.19,
    ry: 3.41,
    transform: "rotate(-11.28 -8.729 820.901)",
    fill: "#f6f7f9"
  }), React.createElement("ellipse", {
    cx: 442.94,
    cy: 305.2,
    rx: 13.84,
    ry: 2.34,
    transform: "rotate(-11.28 95.849 803.52)",
    fill: "#f6f7f9"
  }), React.createElement("ellipse", {
    cx: 497.9,
    cy: 281.6,
    rx: 10.94,
    ry: 1.85,
    transform: "rotate(-11.28 150.787 779.907)",
    fill: "#f6f7f9"
  }), React.createElement("ellipse", {
    cx: 392.21,
    cy: 331.98,
    rx: 20.19,
    ry: 3.41,
    transform: "rotate(-11.28 45.152 830.26)",
    fill: "#f6f7f9"
  }), React.createElement("ellipse", {
    cx: 473.66,
    cy: 319.22,
    rx: 20.19,
    ry: 3.41,
    transform: "rotate(-11.28 126.57 817.545)",
    fill: "#f6f7f9"
  }), React.createElement("path", {
    fill: "#f6f7f9",
    d: "M446.966 132.895l43.64-8.705 1.999 10.023-43.64 8.704zM524.61 404.77l-1.29-1.28a1.39 1.39 0 0 1 0-2l11.24-11.24a1.39 1.39 0 0 1 2 0l11.23 11.23a1.39 1.39 0 0 1 0 2l-1.32 1.29a1.39 1.39 0 0 1-2 0l-6.63-7v16.62a1.38 1.38 0 0 1-1.38 1.39h-1.85a1.39 1.39 0 0 1-1.39-1.39v-16.57l-6.64 7a1.37 1.37 0 0 1-1.97-.05z"
  }), React.createElement("path", {
    d: "M535.54 380.08a22.8 22.8 0 1 1-22.79 22.8 22.82 22.82 0 0 1 22.79-22.8m0-3a25.8 25.8 0 1 0 25.79 25.8 25.79 25.79 0 0 0-25.79-25.8zM524.61 589.77l-1.29-1.28a1.39 1.39 0 0 1 0-2l11.24-11.24a1.39 1.39 0 0 1 2 0l11.23 11.23a1.39 1.39 0 0 1 0 2l-1.32 1.29a1.4 1.4 0 0 1-2 0l-6.66-7v16.62a1.39 1.39 0 0 1-1.39 1.39h-1.81a1.38 1.38 0 0 1-1.38-1.39v-16.62l-6.64 7a1.37 1.37 0 0 1-1.98 0z",
    fill: "#f6f7f9"
  }), React.createElement("path", {
    d: "M535.54 565.07a22.8 22.8 0 1 1-22.79 22.79 22.82 22.82 0 0 1 22.79-22.79m0-3a25.8 25.8 0 1 0 25.79 25.79 25.79 25.79 0 0 0-25.79-25.79z",
    fill: "#f6f7f9"
  }), React.createElement("path", {
    d: "M931.57 634.5s7.14 9.33-3.29 23.41-19 26-15.55 34.76c0 0 15.73-26.16 28.54-26.52s4.39-15.92-9.7-31.65z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M931.57 634.5a11.49 11.49 0 0 1 1.46 2.92c12.5 14.68 19.15 28.38 7.14 28.73-11.19.32-24.61 20.32-27.82 25.37a9.11 9.11 0 0 0 .38 1.15s15.73-26.16 28.54-26.52 4.39-15.92-9.7-31.65z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M944.81 646.39c0 3.28-.37 5.94-.83 5.94s-.82-2.66-.82-5.94.46-1.74.91-1.74.74-1.55.74 1.74z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M949.39 650.31c-2.89 1.57-5.4 2.52-5.62 2.12s2-2 4.83-3.57 1.75-.42 2 0 1.67-.09-1.21 1.45z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M893.88 634.5s-7.13 9.33 3.3 23.41 19 26 15.55 34.76c0 0-15.73-26.16-28.54-26.52s-4.38-15.92 9.69-31.65z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M893.88 634.5a11.71 11.71 0 0 0-1.45 2.92c-12.5 14.68-19.15 28.38-7.14 28.73 11.18.32 24.61 20.32 27.82 25.37a11.06 11.06 0 0 1-.38 1.15s-15.73-26.16-28.54-26.52-4.38-15.92 9.69-31.65z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M880.62 646.39c0 3.28.37 5.94.82 5.94s.83-2.66.83-5.94-.46-1.74-.92-1.74-.73-1.55-.73 1.74z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M876.07 650.31c2.88 1.57 5.4 2.52 5.61 2.12s-1.94-2-4.82-3.57-1.75-.42-2 0-1.67-.09 1.21 1.45z",
    fill: "#ffd037"
  }), React.createElement("ellipse", {
    cx: 912.73,
    cy: 752.6,
    rx: 74.6,
    ry: 11.45,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M951.13 680.1l-.36 2.91-.5 4.12-.21 1.71-.5 4.12-.22 1.72-.53 4.09-5.71 46.8c-.51 4.18-7.33 7.43-15.57 7.43h-29.66c-8.24 0-15.06-3.25-15.57-7.43l-5.68-46.8-.51-4.11-.2-1.72-.51-4.12-.21-1.71-.5-4.12-.36-2.91c-.28-2.36 3.41-4.36 8.07-4.36h60.67c4.65.05 8.35 2.05 8.06 4.38z",
    fill: "#65617d"
  }), React.createElement("path", {
    fill: "#9d9cb5",
    d: "M950.77 683.01l-.5 4.11h-75.08l-.5-4.11h76.08zM950.06 688.84l-.5 4.12h-73.65l-.51-4.12h74.66zM949.34 694.67l-.5 4.12h-72.22l-.5-4.12h73.22z"
  }));
};

UndrawCollection.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawCollection;